// extracted by mini-css-extract-plugin
export default {"sidebar":"ProjectStatusRow-module__sidebar___bB0Np"};